import { render, staticRenderFns } from "./board-socket.vue?vue&type=template&id=445a375a"
import script from "./board-socket.vue?vue&type=script&lang=ts"
export * from "./board-socket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports